module.exports = __webpack_public_path__ + "img/rover.d3b6480b.svg";